import { render, staticRenderFns } from "./payment-stat.vue?vue&type=template&id=b98d3fcc&scoped=true&"
import script from "./payment-stat.js?vue&type=script&lang=js&"
export * from "./payment-stat.js?vue&type=script&lang=js&"
import style0 from "./payment-stat.scss?vue&type=style&index=0&id=b98d3fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98d3fcc",
  null
  
)

export default component.exports